import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClassificacaoTipoMultiselectComponent } from './classificacao-tipo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClassificacaoTipoMultiselectComponent
    ],
    exports: [
        ClassificacaoTipoMultiselectComponent
    ]
})
export class ClassificacaoTipoMultiselectModule { }
